export const Reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_USER": {
      return {
        data: action.payload,
        loggedIn: true,
        address: state.address,
        extra: state.extra,
      };
    }

    case "USER_DATA": {
      return {
        data: state.data,
        loggedIn: state.loggedIn,
        address: state.address,
        extra: action.payload,
      };
    }

    case "LOGOUT_USER":
      return {
        data: action.payload,
        loggedIn: false,
        address: [],
        extra: state.extra,
      };

    case "SET_ADDRESS":
      return {
        data: state.data,
        loggedIn: state.loggedIn,
        address: action.payload,
        extra: state.extra,
      };

    case "ADD_ADDRESS":
      return {
        data: state.data,
        loggedIn: state.loggedIn,
        address: [...state.address, action.payload],
        extra: state.extra,
      };

    default:
      return state;
  }
};
